export default (value = null) => ({
  open: false,
  value: value,
  init() {},
});
